import React, { useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import authAPI from "../api/auth";

function ConfirmEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [tokenUsed, setTokenUsed] = useState(false); // Track if token has been used
  
  const token = searchParams.get("token");

  useEffect(() => {
    const confirmEmail = async () => {
      if (!token) {
        setError("Invalid confirmation link. Please check your email for the correct link.");
        setIsLoading(false);
        return;
      }

      // Prevent multiple confirmation attempts with the same token
      if (tokenUsed) {
        console.log("[CONFIRM EMAIL] Token already used, skipping confirmation");
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError("");
      setMessage("");
      setTokenUsed(true); // Mark token as being used to prevent reuse

      try {
        console.log("[CONFIRM EMAIL] Confirming email with token...");
        const response = await authAPI.confirmEmail(token);
        console.log("[CONFIRM EMAIL] Email confirmation successful:", response);
        setMessage(response.message || "Email confirmed successfully. You can now login.");
        
        // Redirect to login after 3 seconds
        setTimeout(() => {
          console.log("[CONFIRM EMAIL] Redirecting to login after successful confirmation");
          navigate("/login", { 
            state: { 
              message: "Email confirmed successfully! You can now login." 
            } 
          });
        }, 3000);
      } catch (err) {
        console.error("[CONFIRM EMAIL] Email confirmation error:", err);
        const errorMessage = err.response?.data?.detail || err.message || "Failed to confirm email. The link may be invalid, expired, or already used. Please try registering again.";
        setError(errorMessage);
        
        // If email is already verified, redirect after showing message
        if (errorMessage.includes("already confirmed") || errorMessage.includes("already been used")) {
          setTimeout(() => {
            console.log("[CONFIRM EMAIL] Redirecting to login - email already confirmed");
            navigate("/login", { 
              state: { 
                message: "Your email is already confirmed. You can login directly." 
              } 
            });
          }, 3000);
        }
      } finally {
        setIsLoading(false);
      }
    };

    confirmEmail();
  }, [token]); // Only run when token changes, tokenUsed check inside prevents reuse

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0B1220",
      padding: "20px"
    }}>
      <div style={{
        width: "100%",
        maxWidth: 420,
        background: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: 16,
        padding: 24
      }}>
        <h2 className="page-title" style={{ color: "#fff", marginBottom: 24, textAlign: "center" }}>
          Confirm Your Email
        </h2>
        
        {isLoading && (
          <div style={{
            textAlign: "center",
            color: "#94a3b8",
            fontSize: 14,
            padding: 20
          }}>
            Confirming your email...
          </div>
        )}

        {message && (
          <div>
            <div style={{
              color: "#10b981",
              fontSize: 14,
              marginBottom: 16,
              padding: 16,
              background: "rgba(16,185,129,0.1)",
              border: "2px solid rgba(16,185,129,0.3)",
              borderRadius: 12,
              textAlign: "center"
            }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>✓</div>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>
                {message}
              </div>
              <div style={{ fontSize: 12, marginTop: 8, color: "#6ee7b7" }}>
                Redirecting to login page...
              </div>
            </div>
          </div>
        )}
        
        {error && (
          <div>
            <div style={{
              color: "#fca5a5",
              fontSize: 14,
              marginBottom: 16,
              padding: 16,
              background: "rgba(239,68,68,0.1)",
              border: "2px solid rgba(239,68,68,0.3)",
              borderRadius: 12
            }}>
              <div style={{ fontSize: 20, marginBottom: 8 }}>✗</div>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>
                Email Confirmation Failed
              </div>
              <div style={{ fontSize: 13, lineHeight: 1.6 }}>
                {error}
              </div>
            </div>
          </div>
        )}

        {!isLoading && (
          <div style={{ marginTop: 16, textAlign: "center" }}>
            <Link 
              to="/login" 
              style={{
                color: "#60a5fa",
                fontSize: 14,
                textDecoration: "none",
                marginRight: 16
              }}
            >
              Go to Login
            </Link>
            {error && (
              <Link 
                to="/register" 
                style={{
                  color: "#60a5fa",
                  fontSize: 14,
                  textDecoration: "none"
                }}
              >
                Register Again
              </Link>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ConfirmEmail;

